var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBraveLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 112.4 131.9",
    style: {
      enableBackground: "new 0 0 112.4 131.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#c_00000127009694348489516370000011282869654941864072_);}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.382)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -336.836,
    y1: 5.6297,
    x2: -335.8352,
    y2: 5.6297,
    gradientTransform: "matrix(112.31 0 0 131.86 37829.6719 -676.3763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF5500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4099,
    style: {
      stopColor: "#FF5500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    style: {
      stopColor: "#FF2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108,31.6l3.1-7.6c0,0-3.9-4.2-8.7-9c-4.8-4.8-14.9-2-14.9-2L76,0H35.5L24,13.1c0,0-10.1-2.8-14.9,2 s-8.7,9-8.7,9l3.1,7.6l-3.9,11.2c0,0,11.6,43.8,12.9,49.2c2.7,10.5,4.5,14.6,12.1,20c7.6,5.3,21.3,14.6,23.6,16 c2.2,1.4,5.1,3.8,7.6,3.8s5.3-2.4,7.6-3.8c2.2-1.4,16-10.7,23.6-16s9.4-9.4,12.1-20c1.4-5.4,12.9-49.2,12.9-49.2L108,31.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,21.4c0,0,14.8,17.9,14.8,21.8c0,3.8-1.9,4.8-3.7,6.8L84.2,61.8c-1.1,1.1-3.2,2.8-2,5.9 c1.3,3,3.2,6.9,1.1,10.9c-2.1,3.9-5.7,6.6-8,6.1c-2.3-0.4-7.8-3.3-9.8-4.6c-2-1.3-8.3-6.5-8.3-8.5s6.6-5.6,7.8-6.4 c1.2-0.8,6.7-4,6.8-5.2c0.1-1.2,0.1-1.6-1.6-4.7s-4.6-7.2-4.1-9.9s5.2-4.1,8.6-5.4c3.4-1.3,9.9-3.7,10.7-4.1c0.8-0.4,0.6-0.7-1.9-1 c-2.5-0.2-9.4-1.2-12.6-0.3s-8.5,2.2-9,2.9c-0.4,0.7-0.8,0.7-0.4,3.2c0.4,2.4,2.8,14.2,3,16.3s0.7,3.5-1.6,4 c-2.2,0.5-6,1.4-7.3,1.4s-5.1-0.9-7.3-1.4s-1.8-1.9-1.6-4s2.5-13.8,3-16.3c0.4-2.4,0.1-2.5-0.4-3.2c-0.4-0.7-5.8-2-9-2.9 s-10.1,0-12.6,0.3c-2.5,0.2-2.7,0.6-1.9,1c0.8,0.4,7.3,2.8,10.7,4.1s8.1,2.7,8.6,5.4s-2.4,6.8-4.1,9.9c-1.6,3.1-1.7,3.4-1.6,4.7 c0.1,1.2,5.6,4.4,6.8,5.2s7.8,4.4,7.8,6.4s-6.3,7.2-8.3,8.5s-7.4,4.1-9.8,4.6c-2.3,0.4-5.9-2.2-8-6.1s-0.2-7.8,1.1-10.9 c1.3-3-0.9-4.7-2-5.9L16.2,50c-1.9-2-3.7-3-3.7-6.8s14.8-21.8,14.8-21.8s12.5,2.4,14.2,2.4s5.3-1.4,8.7-2.5s5.6-1.1,5.6-1.1 s2.2,0,5.6,1.1c3.4,1.1,7,2.5,8.7,2.5C71.8,23.8,84.3,21.4,84.3,21.4L84.3,21.4z M73.2,89.9c0.9,0.6,0.4,1.7-0.5,2.2 c-0.8,0.6-12.1,9.3-13.1,10.3s-2.7,2.6-3.8,2.6s-2.7-1.6-3.8-2.6s-12.3-9.7-13.1-10.3c-0.8-0.6-1.4-1.7-0.5-2.2 c0.9-0.6,3.8-2,7.7-4.1c4-2.1,8.9-3.8,9.7-3.8c0.8,0,5.7,1.7,9.7,3.8C69.4,87.9,72.2,89.4,73.2,89.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c_00000150102798996526689060000008708702453806886314_",
    gradientUnits: "userSpaceOnUse",
    x1: -336.197,
    y1: 28.329,
    x2: -335.2184,
    y2: 28.329,
    gradientTransform: "matrix(93.219 0 0 23.76 31351.1094 -661.1972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF452A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF2000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "c",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#c_00000150102798996526689060000008708702453806886314_)"
    },
    d: " M87.5,13.1L76,0H35.5L24,13.1c0,0-10.1-2.8-14.9,2c0,0,13.5-1.2,18.1,6.3c0,0,12.5,2.4,14.2,2.4s5.3-1.4,8.7-2.5s5.6-1.1,5.6-1.1 s2.2,0,5.6,1.1s7,2.5,8.7,2.5s14.2-2.4,14.2-2.4c4.6-7.5,18.1-6.3,18.1-6.3C97.6,10.3,87.5,13.1,87.5,13.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraveLogo);
export default __webpack_public_path__ + "static/media/brave_logo.4c4e2324122ea7ff1b6066309cc47328.svg";
export { ForwardRef as ReactComponent };